// Central config for every integration's success page.
// Naya integration add karna ho to bas yahan ek entry jodo (logo public/svg me
// rakho) — component aur route waise ke waise rahenge.

// App ka apna brand color (theme) — sab integrations ke liye yahi use hota hai.
export const APP_ACCENT = "#5f33e1";
export const APP_LOGO = "/svg/Rexpt-Logo.svg";

export const INTEGRATIONS = {
  hubspot: {
    label: "HubSpot",
    logo: "/svg/hubspot.svg",
  },
  clover: {
    label: "Clover",
    logo: "/svg/clover.svg", // logo public/svg me na ho to fallback initial dikhega
  },
  zapier: {
    label: "Zapier",
    logo: null, // logo aane par yahan path daal dena
  },
  make: {
    label: "Make.com",
    logo: null,
  },
  makecom: {
    label: "Make.com",
    logo: null,
  },
};

// Unknown platform aaye to bhi page tutna nahi chahiye -> safe fallback.
export function getIntegration(platform) {
  const key = String(platform || "").toLowerCase();
  if (INTEGRATIONS[key]) {
    return { initial: INTEGRATIONS[key].label.charAt(0), ...INTEGRATIONS[key] };
  }

  const label = key
    ? key.charAt(0).toUpperCase() + key.slice(1)
    : "Your app";
  return { label, logo: null, initial: label.charAt(0).toUpperCase() };
}
